module.exports = __webpack_public_path__ + "static/media/slider_5.71b145bc.webp";